import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dimensionUnitOfMeasure: {
    description: 'settings.displayoptions.dimensionUOM',
    defaultMessage: 'Dimension',
    id: 'HSsWQY',
  },
  weightUnitOfMeasure: {
    description: 'settings.displayoptions.weightUOM',
    defaultMessage: 'Weight',
    id: 'lXhJoa',
  },
  useAdvancedProductDisplay: {
    description: 'settings.displayoptions.useAdvancedProductDisplay',
    defaultMessage: 'Product Type',
    id: 'PgQ/Ee',
  },
  customsContentType: {
    description: 'settings.international.customsContentType',
    defaultMessage: 'Default Content Type',
    id: 's06VYm',
  },
  customsNonDelivery: {
    description: 'settings.international.customsNonDelivery',
    defaultMessage: 'Non-Delivery Option',
    id: 'Q3fzAd',
  },
  createCustomsItems: {
    description: 'settings.international.createCustomsItems',
    defaultMessage: 'Customs Declarations',
    id: 'dk+qJf',
  },
  customsItemDescription: {
    description: 'settings.international.customsItemDescription',
    defaultMessage: 'Description',
    id: 'Q3uJbp',
  },
  customsItemQty: {
    description: 'settings.international.customsItemQty',
    defaultMessage: 'Quantity',
    id: 'OAAkge',
  },
  customsItemValue: {
    description: 'settings.international.customsItemValue',
    defaultMessage: 'Value',
    id: 'l6PgFE',
  },
  customsItemCountry: {
    description: 'settings.international.customsItemCountry',
    defaultMessage: 'Country of Origin',
    id: 'u/mw5s',
  },
  customsItemHarmonization: {
    description: 'settings.international.customsItemHarmonization',
    defaultMessage: 'Harmonization Code',
    id: '4AKGRT',
  },
  customsSigner: {
    description: 'settings.international.customsSigner',
    defaultMessage: 'Sign Customs As',
    id: 'xWNJTA',
  },
  exemptionOrITN: {
    description: 'settings.international.exemptionOrITN',
    defaultMessage: 'Would you like to use your ITN/Tax ID*, VAT Number,* or <a>USPS Exemption Code for AES?</a>',
    id: 'IaEew9',
  },
  iTNTaxId: {
    description: 'settings.international.iTNTaxId',
    defaultMessage: 'Tax ID',
    id: 'CfH6GI',
  },
  iTNSetting: {
    description: 'settings.international.iTNSetting',
    defaultMessage: 'Choose one',
    id: 'AtO8JE',
  },
  defaultExemptionCode: {
    description: 'settings.international.defaultExemptionCode',
    defaultMessage: 'Default USPS Exemption Code',
    id: '1F/3r0',
  },
  fCMITracking: {
    description: 'settings.international.fCMITracking',
    defaultMessage: 'Send non-trackable Tracking Numbers to Marketplaces',
    id: 'RmYD++',
  },
  returnService: {
    description: 'settings.shipping.returnService',
    defaultMessage: 'Same as outbound',
    id: 'Pgv3Ij',
  },
  returnPackage: {
    description: 'settings.shipping.returnPackage',
    defaultMessage: 'Same as outbound',
    id: '7T39V2',
  },
  returnTracking: {
    description: 'settings.shipping.returnTracking',
    defaultMessage: 'Automatically mark returns as "Received" if <a>tracked</a>.',
    id: 'DIFdAa',
  },
  isQuickshipAllowed: {
    description: 'settings.quickship',
    defaultMessage: 'QuickShip',
    id: 'bOvKfw',
  },
  billDutiesAndTaxesToPayor: {
    description: 'Message for seller setting stored in: settings.international.billDutiesAndTaxesToPayor',
    defaultMessage: 'Turn Guaranteed Prepaid Duties and Taxes on for all international orders',
    id: 'sQHRjh',
  },
  customsStoreCurrency: {
    description: 'settings.international.customsStoreCurrency',
    defaultMessage: 'Use store currency on customs form',
    id: 'vOMFKa',
  },
});

export const SellerSettings = {
  dimensionUnitOfMeasure: { key: 'UnitOfMeasure:Dimension' },
  weightUnitOfMeasure: { key: 'UnitOfMeasure:Weight' },
  useAdvancedProductDisplay: { key: 'UseAdvancedProductDisplay' },
  customsContentType: { key: 'CustomsContentType' },
  customsNonDelivery: { key: 'CustomsNonDelivery' },
  createCustomsItems: { key: 'CreateCustomsItems' },
  customsItemDescription: { key: 'CustomsItemDescription' },
  customsItemQty: { key: 'CustomsItemQty' },
  customsItemValue: { key: 'CustomsItemValue' },
  customsItemCountry: { key: 'CustomsItemCountry' },
  customsItemHarmonization: { key: 'CustomsItemHarmonization' },
  customsSigner: { key: 'CustomsSigner' },
  exemptionOrITN: { key: 'ExemptionOrITN' },
  enableDropship: { key: 'EnableDropship' },
  iTNTaxId: { key: 'ITNTaxId' },
  iTNSetting: { key: 'ITNSetting' },
  defaultExemptionCode: { key: 'DefaultExemptionCode' },
  fCMITracking: { key: 'FCMITracking' },
  addToWebHook: { key: 'AddToWebHook' },
  InventoryShipNoStock: { key: 'Inventory:ShipNoStock' },
  InventoryShipUnknown: { key: 'Inventory:ShipUnknown' },
  InventoryReOrderThreshold: { key: 'Inventory:ReOrderThreshold' },
  InventoryShipNoWarehouse: { key: 'Inventory:ShipNoWarehouse' },
  InventoryTrackingEnabled: { key: 'Inventory:TrackingEnabled' },
  orderReportSorting: { key: 'OrderReportSorting' },
  hideOrderReportImages: { key: 'HideOrderReportImages' },
  simpleOrderSummary: { key: 'SimpleOrderSummary' },
  orderSummaryMasterSku: { key: 'OrderSummaryMasterSku' },
  orderSummaryScanToViewBarcode: { key: 'ShowBarcodeOnOrderSummary' },
  pickListGrouping: { key: 'PickListGrouping' },
  pickListSorting: { key: 'PickListSorting' },
  pickListImages: { key: 'PickListImages' },
  pickListMasterSku: { key: 'PickListMasterSku' },
  pickListOrderNumbers: { key: 'PickListOrderNumbers' },
  pickListZeroQuantity: { key: 'PickListZeroQuantity' },
  pickListInventoryCounts: { key: 'PickListInventoryCounts' },
  pickListWarehouseLocation: { key: 'PickListWarehouseLocation' },
  pickListIncludeLotId: { key: 'IncludeLotIdInPickList' },
  pickListHideItemOptions: { key: 'HideItemOptions' },
  pickListDefaultTemplateKey: { key: 'PickListDefaultTemplateKey' },
  packingSlipFormat: { key: 'PSFormat' },
  packingSlipSorting: { key: 'PSItemSorting' },
  packingSlipLogos: { key: 'EnablePackingSlipLogos' },
  packingSlipPrices: { key: 'PackingSlipPrices' },
  packingSlipSkus: { key: 'PackingSlipsSkus' },
  packingSlipBarcode: { key: 'PackingSlipBarcode' },
  packingSlipInventoryLocation: { key: 'ShowInventoryLocationOnPackingSlip' },
  packingSlipZeroQuantity: { key: 'PackingSlipZeroQuantity' },
  packingSlipShowDiscounts: { key: 'PackingSlipShowDiscounts' },
  packingSlipReturnQrCode: { key: 'PackingSlipReturnQrCode' },
  serialNumberEnforcement: { key: 'SerialNumberEnforcement' },
  setupComplete: { key: 'SetupComplete' },
  shipmentManifestItems: { key: 'ManifestItems' },
  labelFileType: { key: 'LabelFileType' },
  labelOutput: { key: 'LabelOutput' },
  labelDpi: { key: 'LabelDPI' },
  batchSummaryPage: { key: 'BatchSummaryPage' },
  returnService: { key: 'ReturnService' },
  returnServiceCollectionGuid: { key: 'ReturnServiceCollectionGuid' },
  returnPackage: { key: 'ReturnPackage' },
  returnTracking: { key: 'ReturnTracking' },
  AutoSplitEnabled: { key: 'EnableAutoSplitting' },
  labelPrintOrder: { key: 'LabelPrintOrder' },
  enableLabelLogos: { key: 'EnableLabelLogos' },
  rubberStamp1: { key: 'RubberStamp1' },
  rubberStamp2: { key: 'RubberStamp2' },
  rubberStamp3: { key: 'RubberStamp3' },
  extendShipDate: { key: 'ExtendShipDate' },
  extendShipDateAfter: { key: 'ExtendShipDateAfter' },
  onboardLabelStepComplete: { key: 'Onboard:LabelsComplete' },
  isQuickshipAllowed: { key: 'QuickShip' },
  customLabelLayouts: { key: 'CustomLabelLayouts' },
  is3PLPlanEnabled: { key: 'EnableFulfillmentProviderBundle' },
  gtmBrand: { key: 'ShipStationUI.GtmBrand' },
  sellerOnboardingJson: { key: 'ShipStationUI.SellerOnboardingJson' },
  sellerFTUWizardJson: { key: 'SellerFTUWizardJson' },
  sellerFulfillmentFTUWizardJson: { key: 'SellerFulfillmentFTUWizardJson' },
  sellerPackingRecommendationsFTUJson: { key: 'PackingRecommendationsFTUWizardJson' },
  unlockFulfilledByShipstationASN: { key: 'UnlockFulfilledByShipstationASN' },
  sellerOnboardingVariant: { key: 'ShipStationUI.SellerOnboardingVariant' },
  recurlyPaymentNickname: { key: 'RecurlyPaymentNickname' },
  enableCubiscan: { key: 'EnableCubiScan' },
  isODBCEnabled: { key: 'IsODBCEnabled' },
  enableShipStationConnectOdbc: { key: 'EnableShipStationConnectOdbc' },
  insuranceCarrierEnabled: { key: 'Insurance.CarrierEnabled' },
  insuranceExternalEnabled: { key: 'Insurance.ExternalEnabled' },
  insuranceSystemAutomationApplyParcelGuard: {
    key: 'Insurance.SystemAutomationApplyParcelGuard',
  },
  insuranceSystemAutomationApplyXCover: {
    key: 'Insurance.SystemAutomationApplyXCover',
  },
  insuranceSystemAutomationPreferenceInsureByRules: { key: 'Insurance.SystemAutomationPreferenceInsureByRules' },
  insuranceSystemAutomationPreferenceNone: { key: 'Insurance.SystemAutomationPreferenceNone' },
  insuranceSystemAutomationReturnApplyParcelGuard: { key: 'Insurance.SystemAutomationReturnApplyParcelGuard' },
  insuranceSystemAutomationReturnApplyXCover: { key: 'Insurance.SystemAutomationReturnApplyXCover' },
  insuranceSystemAutomationReturnPreferenceNone: { key: 'Insurance.SystemAutomationReturnPreferenceNone' },
  isSmartRoutingEnabled: { key: 'EnableSmartOrderRouting' },
  canShareUPSAuctaneRatesWithProviders: {
    key: 'CanShareUPSAuctaneRatesWithProviders',
  },
  isSmartOrderRoutingSetupComplete: { key: 'IsSmartOrderRoutingSetupComplete' },
  isCustomRateShopperSetupComplete: { key: 'IsCustomRateShopperSetupComplete' },
  isAutomationRulesSetupComplete: { key: 'IsAutomationRulesSetupComplete' },
  isProductPresetsSetupComplete: { key: 'IsProductPresetsSetupComplete' },
  isServiceMappingsSetupComplete: { key: 'IsServiceMappingsSetupComplete' },
  selectedFulfillmentStrategy: { key: 'SelectedFulfillmentStrategy' },
  shouldUseFulfillmentProviders: { key: 'ShouldUseFulfillmentProviders' },
  isAccountEmailVerified: { key: 'IsAccountEmailVerified' },
  brandedTrackingEmailExperienceExisting: {
    key: 'BrandedTrackingEmailExperienceExisting',
  },
  brandedTrackingEmailExperienceNew: {
    key: 'BrandedTrackingEmailExperienceNew',
  },
  isSmartFillActive: { key: 'IsShipAIActive' }, // this is the Seller Setting names on the backend and dbo.Default table
  smartFillConfigurationData: { key: 'SmartFillConfigurationData' },
  shouldSmartFillOverwriteMarketplaceWeight: {
    key: 'ShouldSmartFillOverwriteMarketplaceWeight',
  },
  totalOrderWithSmartFillApplied: { key: 'TotalOrderWithSmartFillApplied' },
  isSmartFillPackageEnabled: { key: 'IsSmartFillPackageEnabled' },
  isSmartFillSizeEnabled: { key: 'IsSmartFillSizeEnabled' },
  isSmartFillWeightEnabled: { key: 'IsSmartFillWeightEnabled' },
  isSmartFillHashKeyManagementEnabled: {
    key: 'IsSmartFillHashKeyManagementEnabled',
  },
  enhancedReturnsSellerAuthToken: { key: 'EnhancedReturnsSellerAuthToken' },
  enhancedReturnsAccountStatus: { key: 'EnhancedReturnsAccountStatus' },
  smartFillEnabledSource: { key: 'IsSmartFillEnabledSource' },
  mobileSortItemsBy: { key: 'MobileSortItemsBy' },
  mobileDefaultToteQuantity: { key: 'MobileDefaultToteQuantity' },
  mobileRequireLocationVerification: { key: 'MobileRequireLocationVerification' },
  mobileShowLocationStep: { key: 'MobileShowLocationStep' },
  isRefundAssistEnabled: { key: 'IsRefundAssistEnabled' },
  isTrialAutoConvertedToFreeNotificationPending: { key: 'IsTrialAutoConvertedToFreeNotificationPending' },
  billDutiesAndTaxesToPayor: { key: 'BillDutiesAndTaxesToPayor' },
  customsStoreCurrency: { key: 'CustomsStoreCurrency' },
  fbsApplicationDate: { key: 'FbsApplicationDate' },
  enableShipstationReturns: { key: 'EnableShipstationReturns' },
  planFeaturesTrialInfo: { key: 'PlanFeaturesTrialInfo' },
  isBuyNow: { key: 'IsBuyNow' },
  phoneLastUpdatedUtc: { key: 'PhoneLastUpdatedUTC' },
  packingRecommendationOptimizationFactor: { key: 'PackingRecommendationOptimizationFactor' },
  sellerPickPackStationFTUWizardJson: { key: 'SellerPickPackStationFTUWizardJson' },
  sellerPickPackStationLayoutJson: { key: 'SellerPickPackStationLayoutJson' },
  hasViewedUpsInvoicedModal: { key: 'HasViewedUpsInvoicedModal' },
  sellerRegistrationApp: { key: 'SellerRegistrationApp' },
};

Object.keys(SellerSettings).forEach((setting) => {
  if (messages[setting]) {
    SellerSettings[setting].messageDescriptor = messages[setting];
  }
});

// this might have issues with JSON blobs being stringified, and so characters added? Maybe set 400 to be safe
export const SellerSettingValueMaxLength = 500;
